import { useClientFetch } from '../context/ClientStatusContext';
import getLegMaterialDetailPozicia from '../function/getLegMaterialDetailPozicia';
import LegislativnyMaterialDetail from '../model/legislativnyMaterial/LegislativnyMaterialDetail';
import { ClientStatus } from '../model/ClientStatus';
import PracovnyKrokEnum from '../model/pracovnyKrok/PracovnyKrokEnum';

interface ReturnType {
  nazovPozicie: string,
  materialDetail: LegislativnyMaterialDetail,
  materialStatus: ClientStatus,
}

export default (
  type: string,
  year: number,
  index: number,
  pracovnyKrokEnum: PracovnyKrokEnum,
): ReturnType => {
  const {
    data,
    status,
  } = useClientFetch(
    getLegMaterialDetailPozicia,
    [type, year, index, pracovnyKrokEnum],
    [],
  );

  return {
    nazovPozicie: data?.nazovPozicie,
    materialDetail: data?.materialDetail,
    materialStatus: status,
  };
};
